import React from 'react';

import { FullPageCentered } from '@kueski-dev/kueski-design-system';

import Footer from 'Redesign_Funnel/components/Footer';

import { Wrapper } from '../EmailVerification.styles';

export const EmailVerificationLayout: React.FC<React.PropsWithChildren<unknown>> = (
  { children },
) => (
  <FullPageCentered>
    <Wrapper>{children}</Wrapper>
    <section className="container">
      <Footer />
    </section>
  </FullPageCentered>
);
